import { registryApi, walterApi } from '../clients/AxiosClients'

/**
 * Retorna todos os estratos inventario cubagem cadastradas no banco de dados
 */
const getAllEstratoInventarioCubagem = async () => {
	return registryApi.get('v1/EstratoInventarioCubagem')
}

export const registraEstratoInventarioProcessamento = (body) => {
	return registryApi.post('v1/EstratoInventarioCubagem/', body)
}

export const ajustaModeloVolumetrico = async (data) => {
	return walterApi.post('/ProcessamentoCubagem/AjustaModeloVolumetrico/', data)
}

export const ajustaModeloAfilamento = async (data) => {
	return walterApi.post('/ProcessamentoCubagem/AjustaModeloAfilamento/', data)
}

export const saveChosenAfilamentoModel = async (data) => {
	return walterApi.post('/ProcessamentoCubagem/SaveChosenAfilamentoModel', data)
}

export const saveChosenVolumetricoModel = async (data) => {
	return walterApi.post('/ProcessamentoCubagem/SaveChosenVolumetricoModel', data)
}

export const getAllVolumetricoWithGraphicByEicbId = async (id) => {
	return walterApi.get(`/StatisticalAnalysis/GetAllVolumetricoWithGraphicByEicbId?id=${id}`)
}

export const getAllAfilamentoWithGraphicByEicbId = async (id) => {
	return walterApi.get(`/StatisticalAnalysis/GetAllAfilamentoWithGraphicByEicbId?id=${id}`)
}

/**
 * Retorna todas as especies para o componente de DropdownFk
 
const getDropdownEspecies = async () => {
    const { data: { result } } = await registryApi.get('/EstratoInventarioCubagem')

    return result.map(especie => {
        return {
            "id": especie.id,
            "Código": `ES-${especie.espe_cd_codigo}`,
            "Descrição": especie.espe_ds_descricao,
            "Nome": especie.espe_ds_nome || "-",
        }
    })
}*/

/**
 * Cadastrar novo estrato inventario cubagem no banco de dados
 * @param {Object} body Estrato inventario cubagem que será cadastrada
 */
const createEstratoInventarioCubagem = async (body) => {
	return registryApi.post('v1/EstratoInventarioCubagem/Async', body)
}

/**
 * Atualiza Estrato inventario cubagem no banco de dados
 * @param {Object} body Estrato inventario cubagem que será atualizada
 */
const updateEstratoInventarioCubagem = async (body) => {
	return registryApi.put('v1/EstratoInventarioCubagem/Async', body)
}

/**
 * Lista dos ids de Estrato inventario cubagem que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Estrato inventario cubagem
 */
const deleteEstratoInventarioCubagemByIdList = async (data) => {
	return registryApi.delete('v1/EstratoInventarioCubagem/DeleteByIdList', {
		data,
	})
}

export {
	getAllEstratoInventarioCubagem,
	createEstratoInventarioCubagem,
	updateEstratoInventarioCubagem,
	deleteEstratoInventarioCubagemByIdList,
}
